import styled from 'styled-components';

export const TrooperView = styled.div`
  display: flex;
  background: #f8f9fb;
`;
